import { ButtonActionTypeEnum } from 'common/enums/ButtonActionTypeEnum'
import { LibraryElementEnum } from '../../src/shared/enums/LibraryElementEnum'
import EntityTypeEnum from '../enums/entityTypeEnum'
import { redirectionTypes } from './buttonTypes'
import { buttonActionsTypes } from './settings'
import structureTypes from './structureTypes'
import toolBoxTypes from './toolBoxTypes'

const createChildlessStructure = (type, styles, options) => ({
  [type]: {
    ...(styles ? { styles } : {}),
    ...(options ? { options } : {}),
  },
})

const layout12Structure = {
  [EntityTypeEnum.Row]: {
    children: [createChildlessStructure(EntityTypeEnum.Column)],
  },
}

const mapToolBoxToStructure = {
  [toolBoxTypes.TOOLBOX_AUDIO]: createChildlessStructure(EntityTypeEnum.Audio),
  [toolBoxTypes.TOOLBOX_IMAGE]: createChildlessStructure(EntityTypeEnum.Image),
  [toolBoxTypes.TOOLBOX_FORM_INPUT]: createChildlessStructure(
    structureTypes.FORM_INPUT,
  ),
  [LibraryElementEnum.LibraryWebinarSessionDateTime]: createChildlessStructure(
    EntityTypeEnum.WebinarSessionDateTime,
  ),
  [toolBoxTypes.TOOLBOX_BUTTON]: createChildlessStructure(
    structureTypes.BUTTON,
  ),
  [toolBoxTypes.TOOLBOX_BLOG_BUTTON]: {
    [structureTypes.BUTTON]: {
      options: {
        action: buttonActionsTypes.sendForm,
        redirectionType: redirectionTypes.customUrl,
      },
    },
  },
  [toolBoxTypes.TOOLBOX_OPEN_URL_BUTTON]: createChildlessStructure(
    structureTypes.BUTTON,
    {},
    {
      action: buttonActionsTypes.openUrl,
    },
  ),
  [LibraryElementEnum.LibrarySection]: {
    [EntityTypeEnum.Section]: {
      children: [layout12Structure],
    },
  },
  [LibraryElementEnum.LibraryPaymentButton]: createChildlessStructure(
    LibraryElementEnum.LibraryPaymentButton,
  ),
  [LibraryElementEnum.LibraryButton]: createChildlessStructure(
    EntityTypeEnum.Button,
  ),
  [LibraryElementEnum.LibraryWebsiteButton]: createChildlessStructure(
    EntityTypeEnum.WebsiteButton,
  ),
  [LibraryElementEnum.LibraryOpenUrlButton]: {
    [EntityTypeEnum.Button]: {
      action: ButtonActionTypeEnum.OpenUrl,
    },
  },
  [toolBoxTypes.TOOLBOX_START_TIMER]: createChildlessStructure(
    structureTypes.START_TIMER,
  ),
  [LibraryElementEnum.LibraryCoupon]: createChildlessStructure(
    LibraryElementEnum.LibraryCoupon,
  ),
}

export const getContainerEntityStructure = type => {
  switch (type) {
    case EntityTypeEnum.BlogPostBody:
    case EntityTypeEnum.BlogPageBody:
    case EntityTypeEnum.BlogPostLayoutBody:
    case EntityTypeEnum.WebsiteBlogPostBody:
    case EntityTypeEnum.WebsiteBlogPageBody:
    case EntityTypeEnum.WebsiteBlogPostLayoutBody:
    case EntityTypeEnum.Body:
      return [EntityTypeEnum.Section, EntityTypeEnum.Row, EntityTypeEnum.Column]
    case EntityTypeEnum.Section:
      return [EntityTypeEnum.Row, EntityTypeEnum.Column]
    case EntityTypeEnum.Row:
      return [EntityTypeEnum.Column]
    default:
      return []
  }
}

export const getMovableEntityStructure = type => {
  switch (type) {
    case EntityTypeEnum.Section:
      return []
    case EntityTypeEnum.Row:
      return [EntityTypeEnum.Section]
    default:
      return [EntityTypeEnum.Section, EntityTypeEnum.Row, EntityTypeEnum.Column]
  }
}

export default mapToolBoxToStructure
